<template>
	<div style="margin: 10px;">
		<el-row>
			<el-col :span="12">
				<el-card class="box-card">
					<h4 class="title">地区访问量</h4>
					<div class="line"></div>
					<!-- <div id="region" style="width: 100%;height:350px;"></div> -->
					<ve-line :data="chartData" :settings="chartSettings" style="width: 100%;height:350px;"></ve-line>
				</el-card>
			</el-col>
			<el-col :span="12">
				<el-card class="box-card">
					<h4 class="title">访问终端设备</h4>
					<div class="line"></div>
					<div id="equiment" style="width: 100%;height:350px;"></div>
				</el-card>
			</el-col>
		</el-row>
		<el-row style="margin-top: 10px;">
			<el-col :span="12">
				<el-card class="box-card">
					<h4 class="title">月访问次数</h4>
					<div class="line"></div>
					<!-- <div id="month" style="width: 100%;height:350px;"></div> -->
					<ve-line :data="chartDatas" :settings="chartSettingss"  style="width: 100%;height:350px;"></ve-line>
				</el-card>
			</el-col>
			<el-col :span="12">
				<el-card class="box-card">
					<h4 class="title">浏览器来源</h4>
					<div class="line"></div>
					<div id="browser" style="width: 100%;height:350px;"></div>
				</el-card>
			</el-col>
			<!-- <el-col :span="8">
				<el-card class="box-card" style="height:calc(100vh - 80px);margin-top: -420px;">
					<el-calendar v-model="value">
					</el-calendar>

				</el-card>
			</el-col> -->
		</el-row>
	</div>
</template>

<script>
	export default {
		data() {
			this.chartSettings = {}
			this.chartSettingss = {
				dimension: 'month',
				metrics: ['number'],
				area: true
			}
			return {
				value: new Date(),
				tag: [],
				chartData: {
					columns: [],
					rows: []
				},
				chartDatas: {
				        columns: [],
				        rows: [
				          
				        ]
				      }
			}
		},
		mounted() {
			this.getRegion();
			this.getEquiment();
			this.getMonth();
			this.getBrowser()
		},
		methods: {
			getRegion() {

				var obj = this;
				obj.$http({
					method: 'get',
					url: 'api/v1/statistics/visit',
					params: {

					},
				}).then((res) => {
					if (res.data.status == 200) {
						this.chartData.columns.push('region', 'number')
						this.chartData.rows = res.data.data.regionVisit

					} else {
						obj.$message.error(res.data.message)
					}
				})
			},
			//访问终端设备
			getEquiment() {
				// 基于准备好的dom，初始化echarts实例
				let myEquiment = this.$echarts.init(document.getElementById('equiment'))
				// 绘制图表
				myEquiment.setOption({
					title: {
						left: 'center'
					},
					tooltip: {
						trigger: 'item',
						formatter: '{a} <br/>{b} : {c} ({d}%)'
					},
					legend: {
						orient: 'vertical',
						left: 'left',
						data: []
					},
					series: [{
						name: '访问来源',
						type: 'pie',
						radius: '55%',
						center: ['50%', '60%'],
						data: [

						],
						emphasis: {
							itemStyle: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: 'rgba(0, 0, 0, 0.5)'
							}
						}
					}]
				});
				var obj = this;
				obj.$http({
					method: 'get',
					url: 'api/v1/statistics/visit',
					params: {

					},
				}).then((res) => {
					if (res.data.status == 200) {
						var tag = []
						for (let i = 0; i < res.data.data.tagVisit.length; i++) {
							tag.push({
								value: res.data.data.tagVisit[i].number,
								name: res.data.data.tagVisit[i].tag
							})
						}
						var region = []
						for (var i = 0; i < res.data.data.tagVisit.length; i++) {
							region.push(res.data.data.tagVisit[i].tag)
						}
						myEquiment.setOption({
							series: {
								data: tag
							},
							legend: {
								data: region
							}
						})
					} else {
						obj.$message.error(res.data.message)
					}
				})
			},
			//月访问次数
			getMonth() {

				var obj = this;
				obj.$http({
					method: 'get',
					url: 'api/v1/statistics/visit',
					params: {

					},
				}).then((res) => {
					if (res.data.status == 200) {
						this.chartDatas.columns.push('month', 'number')
						this.chartDatas.rows = res.data.data.monthVisit
						// var region = []
						// for(var i = 0;i<res.data.data.monthVisit.length;i++){
						// 	region.push(res.data.data.monthVisit[i].month)
						// }
						// var number = []
						// for(var i = 0;i<res.data.data.monthVisit.length;i++){
						// 	number.push(res.data.data.monthVisit[i].number)
						// }
						// 		myMonth.setOption({
						// 		xAxis:{data:region},
						// 		series:{data:number}
						// 	})
					} else {
						obj.$message.error(res.data.message)
					}
				})
			},
			//浏览器来源
			getBrowser() {
				// 基于准备好的dom，初始化echarts实例
				let myBrowser = this.$echarts.init(document.getElementById('browser'))
				// 绘制图表
				myBrowser.setOption({
					color: ['#3398DB'],
					tooltip: {
						trigger: 'axis',
						axisPointer: { // 坐标轴指示器，坐标轴触发有效
							type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
						}
					},
					grid: {
						left: '3%',
						right: '4%',
						bottom: '3%',
						containLabel: true
					},
					xAxis: [{
						type: 'category',
						data: [],
						axisTick: {
							alignWithLabel: true
						}
					}],
					yAxis: [{
						type: 'value'
					}],
					series: [{
						name: '直接访问',
						type: 'bar',
						barWidth: '60%',
						data: [],
						itemStyle: {
							//通常情况下：
							normal: {
								//每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组
								color: function(params) {
									var colorList = [
										
										"#5EB6F9",
									]; //每根柱子的颜色
									return colorList[params.dataIndex];
								}
							},

						}
					}]
				});
				var obj = this;
				obj.$http({
					method: 'get',
					url: 'api/v1/statistics/visit',
					params: {

					},
				}).then((res) => {
					if (res.data.status == 200) {
						var region = []
						for (var i = 0; i < res.data.data.browserVisit.length; i++) {
							region.push(res.data.data.browserVisit[i].browser)
						}
						var number = []
						for (var i = 0; i < res.data.data.browserVisit.length; i++) {
							number.push(res.data.data.browserVisit[i].number)
						}
						myBrowser.setOption({
							xAxis: {
								data: region
							},
							series: {
								data: number
							}
						})
					} else {
						obj.$message.error(res.data.message)
					}
				})
			},
		

		}
	}
</script>

<style scoped="scoped">
	/deep/ .el-card {
		margin-right: 20px;
	}

	/deep/ .el-card__body {
		padding: 0
	}

	.line {
		width: 100%;
		height: 1px;
		background: #000000;
		opacity: 0.2;
	}

	.title {
		text-align: center;
		padding: 17px;
	}
</style>



// WEBPACK FOOTER //
// src/views/operate/operate.vue